"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paperclip = function Paperclip(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M15.625 9.89575C15.4869 9.89575 15.3544 9.95063 15.2567 10.0483C15.1591 10.146 15.1042 10.2785 15.1042 10.4166V17.7083C15.1042 18.3989 14.8298 19.0613 14.3414 19.5497C13.8531 20.0381 13.1907 20.3124 12.5 20.3124C11.8094 20.3124 11.147 20.0381 10.6586 19.5497C10.1702 19.0613 9.89585 18.3989 9.89585 17.7083V6.24992C9.89585 5.83552 10.0605 5.43809 10.3535 5.14506C10.6465 4.85204 11.044 4.68742 11.4584 4.68742C11.8728 4.68742 12.2702 4.85204 12.5632 5.14506C12.8562 5.43809 13.0209 5.83552 13.0209 6.24992V17.7083C13.0209 17.8464 12.966 17.9789 12.8683 18.0765C12.7706 18.1742 12.6382 18.2291 12.5 18.2291C12.3619 18.2291 12.2294 18.1742 12.1317 18.0765C12.0341 17.9789 11.9792 17.8464 11.9792 17.7083V10.4166C11.9792 10.2785 11.9243 10.146 11.8266 10.0483C11.729 9.95063 11.5965 9.89575 11.4584 9.89575C11.3202 9.89575 11.1877 9.95063 11.0901 10.0483C10.9924 10.146 10.9375 10.2785 10.9375 10.4166V17.7083C10.9375 18.1227 11.1021 18.5201 11.3952 18.8131C11.6882 19.1061 12.0856 19.2708 12.5 19.2708C12.9144 19.2708 13.3118 19.1061 13.6049 18.8131C13.8979 18.5201 14.0625 18.1227 14.0625 17.7083V6.24992C14.0625 5.55925 13.7882 4.89687 13.2998 4.40849C12.8114 3.92012 12.149 3.64575 11.4584 3.64575C10.7677 3.64575 10.1053 3.92012 9.61693 4.40849C9.12855 4.89687 8.85419 5.55925 8.85419 6.24992V17.7083C8.85419 18.6752 9.2383 19.6025 9.92203 20.2862C10.6058 20.97 11.5331 21.3541 12.5 21.3541C13.467 21.3541 14.3943 20.97 15.078 20.2862C15.7617 19.6025 16.1459 18.6752 16.1459 17.7083V10.4166C16.1459 10.2785 16.091 10.146 15.9933 10.0483C15.8956 9.95063 15.7632 9.89575 15.625 9.89575Z",
    fill: props.foregroundColor
  }));
};

Paperclip.defaultProps = {
  altText: "Paperclip",
  foregroundColor: "#2D5AB4"
};
Paperclip.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Paperclip;
exports.default = _default;